export enum SearchStatus {
    INITIAL = 1,
    LOADING = 2,
    RESULT = 3,
    EMPTY = 4
}